import { FiPower } from "react-icons/fi";
import Tooltip from "../../ToolTip";
import { useState } from "react";
import Button from "../../Button";
import Modal from "../../Modal";
import { deleteToken } from "../../../actions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { persistStore } from "redux-persist";
import { store } from "../../../app/store";

const ExitComponent = () => {
  const persistor = persistStore(store);
  const dispatch = useDispatch();
  const removeToken = () => dispatch(deleteToken());
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const onExit = () => {
    persistor.pause();
    persistor.flush().then(() => {
      return persistor.purge();
    });
    removeToken();
    navigate("/login");
  };

  return (
    <>
      <Tooltip content="خروج">
        <div
          data-tip="React-tooltip"
          data-for="logout"
          className="cursor-pointer py-2 transform scale-125"
          onClick={() => setShowModal(true)}
        >
          <FiPower color="#FF5E56" />
        </div>
      </Tooltip>
      <Modal
        autoWidth
        isOpen={showModal}
        closemodal={() => setShowModal(false)}
      >
        <div className="p-3">
          <div className="font-semibold text-title text-header text-center">
            آیا مایل به خروج از حساب کاربری خود هستید؟
          </div>
          <div className="grid grid-cols-5 gap-4 mt-5">
            <Button
              className="col-span-2"
              onClick={() => setShowModal(false)}
              variant="cancel"
            >
              خیر
            </Button>
            <Button className="col-span-3" onClick={onExit} variant="error">
              بله، خارج شو
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ExitComponent;
